import React from 'react';
import { useI18n } from 'panda-i18n';
import { CardTitle } from './cn-card-title';
import { CnStatusTag } from '@/components/cn-tag';
import { CnCheckbox } from '@/components/cn-checkbox';
import { CnButton } from '@/components/cn-button';
import { CnButtonGroup } from '@/components/cn-button-group';
import cx from 'classnames';
import './cn-card.scss';
const CardFooterActions = (props) => {
    const { checkBox, buttons = [] } = props;
    const $i18n = useI18n();
    if (!checkBox && !buttons.length)
        return null;
    return (React.createElement(React.Fragment, null,
        checkBox ? (React.createElement("div", { className: "checkbox-group" },
            React.createElement(CnCheckbox, { checked: checkBox.checked, ...checkBox }, $i18n.get({ id: 'Selection', dm: '选择', ns: 'CnCard' })))) : null,
        buttons.length ? (React.createElement(CnButtonGroup, { isReverse: true, shape: "card" }, buttons.map((b, index) => {
            return React.createElement(CnButton, { ...b, key: index });
        }))) : null));
};
/**
 * @category 组件
 * @description 卡片组件
 */
export const CnCard = (props) => {
    const { title, desc, icon, action, subTitle, subDesc, subIcon, subAction, noPadding, tags, children, footAction, className, onClick, ...others } = props;
    const outterTitleProps = {
        title,
        desc,
        icon,
        action,
    };
    const innerTitleProps = {
        title: subTitle,
        desc: subDesc,
        icon: subIcon,
        action: subAction,
    };
    const handleCardClick = (e) => {
        if (typeof onClick === 'function') {
            onClick(e);
        }
    };
    return (React.createElement("div", { onClick: (e) => {
            handleCardClick(e);
        }, className: cx('cn-ui-m-card-wrapper', className), ...others },
        title && React.createElement(CardTitle, { ...outterTitleProps }),
        React.createElement("div", { className: cx('cn-ui-m-card', { 'cn-ui-m-card-no-padding': noPadding }) },
            subTitle && (React.createElement("div", { className: "cn-ui-m-card-header" },
                React.createElement(CardTitle, { ...innerTitleProps }),
                Array.isArray(tags) && tags.length > 0 && (React.createElement("div", { className: "tags" }, tags.map((cnStatusTagProps) => {
                    return (React.createElement("div", { className: "tag-item" },
                        React.createElement(CnStatusTag, { ...cnStatusTagProps })));
                }))))),
            React.createElement("div", { className: "cn-ui-m-card-body" }, children),
            footAction && (React.createElement("div", { className: "cn-ui-m-card-footer" },
                React.createElement(CardFooterActions, { ...footAction }))))));
};
CnCard.displayName = 'CnCard';
CnCard.defaultProps = {
    noPadding: false,
};
